import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { useBreadcrumbsItemContext } from './context.js';
import warn from '../../utils/warn.js';
import { jsx } from '@emotion/react';
import { InteractiveListLink } from '../InteractiveList/InteractiveListLink.js';
import { TextLink } from '../TextLink/TextLink.js';
import { Text } from '../Text/Text.js';
import '../InteractiveList/InteractiveListBaseItem.js';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '@indeed/ifl-icons';
import '../Flex/Flex.js';
import '../Box/Box.js';
import '../LinkProvider/LinkProvider.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/createResponsive.js';

const BREADCRUMBS_ITEM_DEFAULT_TAG = "a";
const BreadcrumbsItem = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    children,
    as = BREADCRUMBS_ITEM_DEFAULT_TAG,
    ...remaningProps
  } = props;
  const context = useBreadcrumbsItemContext(); // could be null or the context object

  if (!context) {
    warn("<BreadcrumbsItem> should only be used as a child of <Breadcrumbs>");
  }
  const itemType = context?.itemType;
  if (itemType === "overflown") {
    return jsx(InteractiveListLink, _extends({
      ref: forwardedRef,
      as: as
    }, remaningProps), children);
  }
  if (itemType === "visible") {
    return jsx(TextLink, _extends({
      ref: forwardedRef,
      as: as
    }, remaningProps), children);
  }
  if (itemType === "current") {
    return jsx(Text, {
      ref: forwardedRef
    }, children);
  }
  return null;
});
BreadcrumbsItem.displayName = "BreadcrumbsItem";

export { BREADCRUMBS_ITEM_DEFAULT_TAG, BreadcrumbsItem };
